import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';
import { TBuildingCondition } from '@brickwise/asset-validation/dist/schema/enums';

interface Props {
  disabled?: boolean;
}

export const BuildingConditionSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <DefaultFastSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.generalinfo.fields.buildingtype.label')}
      fieldName="propertyDetails.buildingCondition"
      options={[
        {
          value: TBuildingCondition.new,
          label: t('general.buildingtype.new'),
        },
        {
          value: TBuildingCondition.old,
          label: t('general.buildingtype.old'),
        },
        // TODO: check if only for builder-owner-model:
        {
          value: TBuildingCondition.renovation,
          label: 'Sanierung',
        },
        {
          value: TBuildingCondition.newDevelopment,
          label: 'Neubau',
        },
      ]}
    />
  );
};
